export default {"src":"/_next/static/media/ads.92270b2d.svg","height":507,"width":1061,"blurWidth":0,"blurHeight":0};